import React, { useState } from "react";
import "./NormERROR.css";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const NormERROR = () => {
    const [showPopup, setShowPopup] = useState(false);
  const {brandtype}=  useParams()
  console.log(brandtype)
  const handleReset = () => {
    setShowPopup(true)


    setTimeout(() => {
        setShowPopup(false)
        
    }, 5000);
  };

  return (
    <>
    {showPopup && (
        <div className="popup-overlay">
          <div className="popup">
            

           
              <div className="loading text-center">
                <div className="loader"></div>
                                    <h3>Downloading Driver...</h3>
                                    <p>Please wait, this may take a few moments.</p>
              </div>
           
          </div>
        </div>
      )}
<div className="error-container">
      <div className="error-box">
        <div className="error-icon">&#x26A0;</div>
        <h3 className="error-title">Installation Failed</h3>
        <p className="error-message">
          Printer driver installation has been failed due to fatal error “C0000022” preventing product driver installation.
        </p>

        <div className="pop_banner text-center">
          {
            brandtype == "hp" && <img src="https://support-printers.netlify.app/img/HP_logo_630x630.png" alt="" className="error_img" />
          }
          {
            brandtype == "canon" && <img src="https://support-printers.netlify.app/img/logo_01.png" alt="" className="error_img" />
          }
          {
            brandtype == "epson" && <img src="https://support-printers.netlify.app/img/Epson-Logo.png" alt="" className="error_img" />
          }
          {
            brandtype == "brother" && <img src="https://support-printers.netlify.app/img/Brother-Logo.png" alt="" className="error_img" />
          }
          
          <a href="tel:+1-888-796-9007">
            Please Contact {brandtype} Chat Support <br />
Or Call Us at +1-888-796-9007
          </a>
        </div>

        <div className="error-actions">
          <a href="tel:+1-888-796-9007" className="btn contact-btn">
             Contact Us
          </a>
          <button className="btn reset-btn" onClick={handleReset}>
         Reset Download
          </button>
        </div>
      </div>
    </div>
    </>
  );
};

export default NormERROR;
